import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M2 24v-3h20v3zm4-7.587h1.237l8.3-8.284-.63-.639-.622-.613L6 15.177zm-1.5 1.5V14.54L15.71 3.344a1.48 1.48 0 0 1 .493-.329 1.546 1.546 0 0 1 1.152 0c.186.075.357.19.512.345l1.202 1.217c.155.145.268.31.337.498.069.187.104.38.104.58 0 .186-.036.372-.106.557-.07.185-.182.354-.335.507L7.875 17.913zM15.537 8.13l-.63-.639-.622-.613z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }